import * as React from "react"

import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';

// import CONFIG from '../../cfg/config';

const odstep: string = '          ';

interface FooterProps extends WithTranslation , WithStyles<typeof styles> {
}

class Footer extends React.Component<FooterProps , any> {

    logoClick = () => {
        window.open("http://virtualsc.com.pl/")
    }

  render() {
    const classes = this.props.classes;

    return (
        <div style={{ padding: "20px 0px 10px", width: "fit-content", margin: 'auto', alignItems: "center", display: "flex"}} onClick={this.logoClick}>
            <ResponsiveImgMaterialUi style={{ height: "15px", width: "138px", padding: "5px 12.5%", cursor: "pointer" }}
                 xs={require('app/assets/logo_bookuj.png').default}
                 md={require('app/assets/logo_bookuj.png').default}
                 lg={require('app/assets/logo_bookuj.png').default}
            />
      </div>
    );
  }
}

const styles = (theme: Theme) => ({
  
});

export default withTranslation()(withStyles(styles)(Footer));